import { ReactNode, createContext } from "react";
import { TicketViewModel } from "../../../interfaces";

interface TicketContextInterface {
  ticket: TicketViewModel;
  refetch?: () => void;
  onTicketUpdate?: (ticketId: number, changes: Partial<TicketViewModel>) => void;
}

interface Props {
  children: ReactNode;
  ticket: TicketViewModel;
  refetch?: () => void;
  onTicketUpdate?: (ticketId: number, changes: Partial<TicketViewModel>) => void;
}

export const TicketContext = createContext({} as TicketContextInterface);

const TicketProvider = ({ children, ticket, refetch, onTicketUpdate }: Props) => {
  return (
    <TicketContext.Provider value={{ ticket, refetch, onTicketUpdate }}>
      {children}
    </TicketContext.Provider>
  );
};

export default TicketProvider;
